import { RadioGroup } from '@headlessui/react'
import { CheckIcon } from '@radix-ui/react-icons'
import { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'

import {
	UPDATE_STATE,
	UPDATE_INCLUDED_CONTROLLER_QUESTIONS,
} from '#app/constants/forms.ts'
import { type FieldComponentProps } from '#types/form/wizard.ts'

export function RadioButtonComponent({
	values,
	fieldName,
	label,
	control,
	id,
	isController = false,
	getValues,
	dispatch,
	handleSubmit,
}: FieldComponentProps) {
	const defaultFormValue = getValues!(fieldName)
	const [shouldSubmit, setShouldSubmit] = useState(false)

	useEffect(() => {
		if (shouldSubmit && handleSubmit) {
			handleSubmit()()
			setShouldSubmit(false)
		}

		return () => {
			setShouldSubmit(false)
		}
	}, [shouldSubmit, handleSubmit])

	const customOnChangeHandler = (e: any, reactHookFormOnChange: any) => {
		if (isController) {
			const chosenAnswer = values?.find(question => question.id === e)

			dispatch!({
				type: UPDATE_STATE,
				fieldName,
				value: chosenAnswer?.id,
			})

			dispatch!({
				type: UPDATE_INCLUDED_CONTROLLER_QUESTIONS,
				id: id!,
				includedQuestions: chosenAnswer?.includedQuestions || [],
			})

			reactHookFormOnChange(e)
		} else {
			const chosenAnswer = values?.find(question => question.title === e)
			dispatch!({
				type: UPDATE_STATE,
				fieldName,
				value: chosenAnswer?.title,
			})

			reactHookFormOnChange(chosenAnswer?.title)
		}

		if (handleSubmit) {
			setShouldSubmit(true)
		}
	}

	return (
		<>
			<div className=" mb-5 w-full pt-5">
				<label className="mb-4 block text-sm font-semibold text-primary-400 md:text-lg">
					{label}
				</label>
				<div className="mx-auto">
					<Controller
						name={fieldName}
						control={control}
						rules={{
							required: 'Please select a storage option',
						}}
						render={({ field: { onChange, value, onBlur, name } }) => (
							<RadioGroup
								value={value || ''}
								onChange={e => {
									customOnChangeHandler(e, onChange)
								}}
								onBlur={onBlur}
								name={name}
							>
								<div className="space-y-2">
									{values?.map(option => (
										<RadioGroup.Option
											key={isController ? option.id : option.title}
											defaultValue={defaultFormValue}
											value={isController ? option.id : option.title}
											className={({ active, checked }) =>
												` ${
													active
														? ' ring-ring ring-offset-2 focus-within:ring-4 focus-visible:ring-4'
														: ''
												}
											  ${
													checked
														? 'bg-primary-400 text-white'
														: 'bg-white hover:bg-primary-300 hover:text-white '
												}
											  relative flex cursor-pointer rounded-lg px-5 py-4 text-primary-400 shadow-md focus:outline-none active:bg-accent active:text-primary-400`
											}
										>
											{({ checked }) => (
												<>
													<div className="flex w-full items-center justify-between">
														<div className="flex items-center">
															<div className="text-sm">
																<RadioGroup.Label as="p" className="font-bold">
																	{option.title}
																</RadioGroup.Label>
																<RadioGroup.Description as="span">
																	<span> {option.subtitle}</span>
																</RadioGroup.Description>
															</div>
														</div>
														{checked && (
															<div className="shrink-0 text-white">
																<CheckIcon className="h-6 w-6" />
															</div>
														)}
													</div>
												</>
											)}
										</RadioGroup.Option>
									))}
								</div>
							</RadioGroup>
						)}
					/>
				</div>
			</div>
		</>
	)
}
